var _circle, _path, _circle2, _circle3, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVideoIconLight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17.5,
    cy: 17.5,
    r: 17.5,
    fill: "#A1A3B2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.54 15.3574C15.8542 15.3574 16.1423 15.5142 16.374 15.7264C16.8498 16.1622 17.4826 16.4287 18.1787 16.4287C18.8204 16.4287 19.4078 16.2019 19.8682 15.8251C20.1568 15.5889 20.5325 15.4154 20.8622 15.5896C21.4964 15.9246 21.9287 16.5901 21.9287 17.3574V23C21.9287 24.1045 21.0332 24.9999 19.9287 25H10C8.89543 25 8 24.1046 8 23V17.3574C8 16.5911 8.43113 15.9261 9.06402 15.5905C9.39387 15.4156 9.77017 15.5893 10.0592 15.8256C10.52 16.2023 11.1082 16.4287 11.75 16.4287C12.446 16.4287 13.0782 16.162 13.5538 15.7263C13.7854 15.5141 14.0735 15.3574 14.3876 15.3574H15.54Z",
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 11.7489,
    cy: 12.6786,
    r: 1.92856,
    stroke: "white",
    strokeWidth: 1.5
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 18.1786,
    cy: 12.6786,
    r: 1.92856,
    stroke: "white",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.8006 16.1828L22.9792 17.7502C22.6617 17.9266 22.4648 18.2612 22.4648 18.6244V21.1361C22.4648 21.5313 22.6976 21.8894 23.0587 22.0499L25.8801 23.3039C26.5414 23.5978 27.2863 23.1137 27.2863 22.3901V17.0569C27.2863 16.2945 26.4671 15.8125 25.8006 16.1828Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoIconLight);
export default __webpack_public_path__ + "static/media/video_icon-light.d56eb17c49f748764984ea16b4c068da.svg";
export { ForwardRef as ReactComponent };